// extracted by mini-css-extract-plugin
module.exports = {"tabs":"tabs_tabs___Sl0C","line":"tabs_line__L_6mB","border":"tabs_border__2fJoE","tab":"tabs_tab__tQpkQ","active":"tabs_active__BPLfB"};